import {Injectable} from '@angular/core';
import {Document} from '../../models/document';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  getImageUrl(
    image: Document | null | undefined,
    width: number | null = null,
    height: number | null = null,
    crop: boolean = true
  ): string {
    if (!image) {
      return '';
    }

    let url = environment.server.url + '/image/' + image.id;

    const params = new URLSearchParams();

    if (width !== null) {
      params.append('w', width.toString());
    }

    if (height !== null) {
      params.append('h', height.toString());
    }

    params.append('c', crop ? '1' : '0');

    url += '?' + params.toString();

    return url;
  }
}
